import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderLayout,
  type LayoutOptions,
} from '@backstage/plugin-scaffolder-react';
import { CollapsibleSection } from './CollapsibleSection';

// Exported as plain options as well as a provided layout. The stock /create
// route registers the layout as a React child; anything rendering a template
// outside that route needs the options (see ../extensions.ts).
export const collapsibleSectionLayoutOptions: LayoutOptions = {
  name: 'CollapsibleSection',
  component: CollapsibleSection,
};

export const CollapsibleSectionLayout = scaffolderPlugin.provide(
  createScaffolderLayout(collapsibleSectionLayoutOptions),
);
